import router from "../../router";
import services from "../services";

const strict = true;

const defaultState = function () {
  return {
    userInfo: {},
    menu: [
      {
        name: "dashboard",
        showName: "mainMenu.homepage",
        routeName: "dashboard",
        icon: "dashboard",
        visible: true
      },
      {
        name: "centroNotifiche",
        showName: "mainMenu.notificationCenter",
        routeName: "centroNotifiche",
        icon: "notifications",
        visible: true
      },
      {
        name: "copertureMassimali",
        showName: "mainMenu.maxCoverage",
        routeName: "copertureMassimali",
        icon: "hands-holding-euro.svg",
        iconType: "internal",
        visible: true
      },
      {
        name: "appointments",
        showName: "mainMenu.bookings",
        routeName: "richiestePrenotazioni",
        icon: "assignment_ind",
        visible: true
      },
      {
        name: "prestazioniEffettuate",
        showName: "mainMenu.serviceDone",
        routeName: "prestazioniEffettuate",
        icon: "all_inbox",
        visible: true
      },
      {
        name: "richiesteRimborso",
        showName: "mainMenu.refundRequests",
        routeName: "richiesteRimborso",
        icon: "euro",
        visible: true
      },
      {
        name: "estrattoConto",
        showName: "mainMenu.estrattoConto",
        routeName: "estrattoConto",
        icon: "fa-solid fa-receipt",
        visible: true
      },
      {
        name: "fondoEstPerTe",
        showName: "mainMenu.fondoEst4you",
        routeName: "fondoEstPerTe",
        icon: "center_focus_strong",
        visible: true
      },
      {
        name: "contatti",
        showName: "mainMenu.contacts",
        routeName: "contatti",
        icon: "stay_current_portrait",
        visible: true
      },
      {
        name: "gestioneFamiliari",
        showName: "mainMenu.gestioneFamiliari",
        routeName: "gestioneFamiliari",
        icon: "fa-solid fa-people-roof",
        visible: true
      },
      {
        name: "versamentoVolontario",
        showName: "mainMenu.versamentoVolontario",
        routeName: "versamentoVolontario",
        icon: "fas fa-hand-holding-usd",
        visible: true
      }
    ],
    consentToDeclare: false,
    profileCompletion: 0,
    validProfileCompletionKeys: [
      "codiceFiscale",
      "username",
      "nome",
      "cognome",
      "sesso",
      "dataNascita",
      "luogoNascita",
      "telefono",
      "telefono3",
      "emailPersonale",
      "email3",
      "domicilioIndirizzo",
      "residenzaIndirizzo",
      "codiceIBAN",
      "pin"
    ]
  };
};

const state = defaultState();

const getters = {
  username: state => (state.userInfo ? state.userInfo.username : null),
  userInfo: state => state.userInfo,
  userFullName: state => state.userInfo.nome + " " + state.userInfo.cognome,
  userPin: state => state.userInfo.pin,
  userInitials: state => {
    if (state.userInfo) {
      return (
        (state.userInfo.nome || "").slice(0, 1) +
        (state.userInfo.cognome || "").slice(0, 1)
      );
    }
    return null;
  },
  profileCompletion: state => state.profileCompletion,
  getMenu: state => state.menu,
  getConsentToDeclare: state => state.consentToDeclare,
  getPrimoAccessoAlreadyDone: state => state.userInfo.primoAccesso,
  getMhPopup: state => state.userInfo.mhPopup, // REQ-MH-01
  getMhGuide: state => state.userInfo.mhGuide, // REQ-MH-05
  getMhRichiestaAppuntamento: state => state.userInfo.mhRichiestaAppuntamento, // REQ-MH-02
  getMhAppuntamenti: state => state.userInfo.mhAppuntamenti, // REQ-MH-06 & REQ-MH-07
  getMhRichiestaRimborso: state => state.userInfo.mhRichiestaRimborso, // REQ-MH-03
  getMhRimborsi: state => state.userInfo.mhRimborsi, // REQ-MH-04
  getMhContatti: state => state.userInfo.mhContatti, // REQ-MH-08
  getMhDataDiTransizione: state => state.userInfo.mhDataDiTransizione, // data di inizio dell'eventuale ultima transizione al gestore dei servizi
  getMhServiceOperatorsPopupAccepted: state =>
    state.userInfo.mhServiceOperatorsPopupAccepted, // se l'utente ha già visualizzato e accettato la popup informativa
  getMhProfilo: state => state.userInfo.mhProfilo, // fondoest/issues#1129
  getMhCopertura: state => state.userInfo.mhCopertura, // fondoest/issues#1124 e fondoest/issues#1125
  getNucleoFamiliare: state => state.userInfo.nucleoFamiliare
};

const mutations = {
  reset(state) {
    const s = defaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  loadingUserInfo(state) {
    state.userInfo = {};
  },
  userInfoLoaded(state, userInfo) {
    state.userInfo = userInfo;
  },
  addMhProfilo(state) {
    if (!state.userInfo["mhProfilo"])
      state.userInfo["mhProfilo"] = state.userInfo["mhRichiestaRimborso"];
  },
  // setDefaultForConsentNull(state) {
  //   state.userInfo["consensoDatiParticolari"] = "N";
  //   state.userInfo["dataDatiParticolari"] = "2023-08-07T14:51:59.478";
  // },
  // setDefaultForPrimoAccesso(state) {
  //   state.userInfo["primoAccesso"] = null;
  //   state.userInfo["domicilioNeedUpdateForPrimoAccesso"] = true;
  //   state.userInfo["domicilioAddressSavedForPrimoAccesso"] = false;
  //   state.userInfo["residenzaNeedUpdateForPrimoAccesso"] = true;
  //   state.userInfo["residenzaAddressSavedForPrimoAccesso"] = false;
  // },
  // setUserAsMutualHelpUser(state) {
  //   state.userInfo["mhPopup"] = "C";
  //   state.userInfo["mhGuide"] = "B";
  //   state.userInfo["mhRichiestaAppuntamento"] = "B";
  //   state.userInfo["mhAppuntamenti"] = "B";
  //   state.userInfo["mhRichiestaRimborso"] = "B";
  //   state.userInfo["mhRimborsi"] = "B";
  //   state.userInfo["mhContatti"] = "B";
  //   state.userInfo["mhProfilo"] = state.userInfo["mhRichiestaRimborso"];
  //   state.userInfo["mhCopertura"] = "B";
  // },
  // setUserAsUniSaluteAndMutualHelpUser(state) {
  //   state.userInfo["mhPopup"] = "C";
  //   state.userInfo["mhGuide"] = "A";
  //   state.userInfo["mhRichiestaAppuntamento"] = "A";
  //   state.userInfo["mhAppuntamenti"] = "A";
  //   state.userInfo["mhRichiestaRimborso"] = "A";
  //   state.userInfo["mhRimborsi"] = "A";
  //   state.userInfo["mhContatti"] = "A";
  //   state.userInfo["mhProfilo"] = state.userInfo["mhRichiestaRimborso"];
  //   state.userInfo["mhCopertura"] = "A";
  // },
  // setUserAsValidNucleoFamiliare(state) {
  //   state.userInfo["nucleoFamiliare"] = true;
  // },
  calculateCompletion(state) {
    let completed = 0;
    let validKeys = state.validProfileCompletionKeys;
    validKeys.forEach(k => {
      // console.log(`${k}: ${state.userInfo[k]}`);
      if (typeof state.userInfo[k] === "undefined") {
        // do nothing because this key is undefined
      } else if (state.userInfo[k] === null) {
        // do nothing because this key is null
      } else if (state.userInfo[k] === "") {
        // do nothing because this key is empty
      } else {
        completed++;
      }
    });
    let result = Math.ceil((completed * 100) / validKeys.length);
    state.profileCompletion = result;
  },
  updateUserInfo(state, fields) {
    state.userInfo = { ...state.userInfo, ...fields };
  },
  updateConiugeMenuVisibility(state) {
    let coniugeHiddenMenuItems = [
      "centroNotifiche",
      "gestioneFamiliari",
      "versamentoVolontario"
    ];
    state.menu
      .filter(m => coniugeHiddenMenuItems.includes(m.name))
      .forEach(m => (m.visible = false));
  },
  updateUserInfoDomicilio(state, result) {
    let domicilioComuneId = state.userInfo.domicilioComuneId
      ? state.userInfo.domicilioComuneId
      : null;
    let city = result.city;
    state.userInfo["domicilioCAP"] = city.cap;
    if (!domicilioComuneId && city) {
      state.userInfo["domicilioComuneDescrizione"] = city.description;
      state.userInfo["domicilioComuneId"] = city.id;
    }
    let province = result.province;
    if (province) {
      state.userInfo["domicilioProvince"] = province.description;
      state.userInfo["domicilioProvinceCode"] = province.code;
      state.userInfo["domicilioProvinceCovered"] = ["RM", "MI", "MB"].includes(
        province.code
      );
    }
  },
  updateUserInfoResidenza(state, result) {
    let residenzaComuneId = state.userInfo.residenzaComuneId
      ? state.userInfo.residenzaComuneId
      : null;
    let city = result.city;
    state.userInfo["residenzaCAP"] = city.cap;
    if (!residenzaComuneId && city) {
      state.userInfo["residenzaComuneDescrizione"] = city.description;
      state.userInfo["residenzaComuneId"] = city.id;
    }
    let province = result.province;
    if (province) {
      state.userInfo["residenzaProvince"] = province.description;
      state.userInfo["residenzaProvinceCode"] = province.code;
      state.userInfo["residenzaProvinceCovered"] = ["RM", "MI", "MB"].includes(
        province.code
      );
    }
  },
  updateUserInfoLavoro(state, result) {
    let lavoroComuneId = state.userInfo.lavoroComuneId
      ? state.userInfo.lavoroComuneId
      : null;
    let city = result.city;
    state.userInfo["lavoroCAP"] = city.cap;
    if (!lavoroComuneId && city) {
      state.userInfo["lavoroComuneDescrizione"] = city.description;
      state.userInfo["lavoroComuneId"] = city.id;
    }
    let province = result.province;
    if (province) {
      state.userInfo["lavoroProvince"] = province.description;
      state.userInfo["lavoroProvinceCode"] = province.code;
      state.userInfo["lavoroProvinceCovered"] = ["RM", "MI", "MB"].includes(
        province.code
      );
    }
  },
  setConsentToDeclare(state, val) {
    state.consentToDeclare = val;
  }
};

const actions = {
  async afterKeycloakLogin({ commit, dispatch }) {
    await dispatch("clearAll", null, { root: true });
    commit("loading/openLoadingDialog", null, { root: true });
    commit("loadingUserInfo");
    await dispatch("login/userInfo", null, { root: true });
    await dispatch("profile/initUserAddressesData", null, { root: true });
  },
  async userInfo({ commit, getters, rootGetters, dispatch }) {
    try {
      // 1. calling userInfo
      let res = await services.loginService.login();
      let userInfo = res.body;
      // 2. fondoest/issues#1349: no more need to copy userInfo.additionalInfo property on userInfo.member object
      // 3. check for foreign addresses on userInfo.member object
      userInfo.member["domicilioIsForeign"] = false;
      userInfo.member["residenzaIsForeign"] = false;
      userInfo.member["lavoroIsForeign"] = false;
      if (
        userInfo.member.domicilioProvinceId &&
        userInfo.member.domicilioProvinceId === 108
      ) {
        userInfo.member["domicilioIsForeign"] = true;
      }
      if (
        userInfo.member.residenzaProvinceId &&
        userInfo.member.residenzaProvinceId === 108
      ) {
        userInfo.member["residenzaIsForeign"] = true;
      }
      if (
        userInfo.member.lavoroProvinceId &&
        userInfo.member.lavoroProvinceId === 108
      ) {
        userInfo.member["lavoroIsForeign"] = true;
      }
      // 4. set the address properties to manage the update domicilio and residenza addresses on primo accesso flow
      let primoAccesso = userInfo.member.primoAccesso;
      if (!primoAccesso || primoAccesso === null) {
        userInfo.member["domicilioNeedUpdateForPrimoAccesso"] = true;
        userInfo.member["domicilioAddressSavedForPrimoAccesso"] = false;
        userInfo.member["residenzaNeedUpdateForPrimoAccesso"] = true;
        userInfo.member["residenzaAddressSavedForPrimoAccesso"] = false;
      } else {
        userInfo.member["domicilioNeedUpdateForPrimoAccesso"] = false;
        userInfo.member["domicilioAddressSavedForPrimoAccesso"] = true;
        userInfo.member["residenzaNeedUpdateForPrimoAccesso"] = false;
        userInfo.member["residenzaAddressSavedForPrimoAccesso"] = true;
      }
      // 5. store userInfo.member informations inside "userInfo" property
      commit("userInfoLoaded", userInfo.member);
      // 6. retrieve member coverages information
      await dispatch("coverages/getCurrentMonths", 11, {
        root: true
      });
      // 7. retrieve nucleo familiare informations (fondoest/issues#1379)
      let memberId = userInfo.member?.idIscritto;
      await dispatch("profile/getNucleoFamiliareFull", memberId, {
        root: true
      });
      let isConiuge = rootGetters["profile/getIsConiuge"];
      if (isConiuge) {
        commit("updateConiugeMenuVisibility");
      }
      // 8. add MH_PROFILO (fondoest/issues#1129)
      commit("addMhProfilo");
      // 9. calling getPin
      let isPinActive = process.env.VUE_APP_IS_PIN_ACTIVE != "false";
      let memberPin = "X";
      if (isPinActive) {
        memberPin = await dispatch("profile/getPin", null, { root: true });
      }
      // 10. update pin value and calculate the profile completion percentage
      commit("updateUserInfo", {
        pin: memberPin
      });
      commit("calculateCompletion");
      // 11. calling getCountriesForIban (from JSON file)
      await dispatch("profile/getCountriesForIban", null, { root: true });
      // 12. get "userInfo" property populated at step 5 to check consents and primoAccesso
      let storedUser = getters["userInfo"];
      //
      //
      // ---> SETS DEFAULTS TO SIMULATE CONSENTS PRIMO ACCESSO FLOW <---
      // commit("setDefaultForConsentNull");
      // ---> SETS DEFAULTS TO SIMULATE PRIMO ACCESSO FLOW <---
      // commit("setDefaultForPrimoAccesso");
      // ---> SETS DEFAULT TO SIMULATE USER AS MUTUAL HELP USER <---
      // commit("setUserAsMutualHelpUser");
      // ---> SETS DEFAULT TO SIMULATE USER AS UNISALUTE AND MUTUAL HELP USER <---
      // commit("setUserAsUniSaluteAndMutualHelpUser");
      // ---> SETS DEFAULT TO SIMULATE USER WITH VALID NUCLEO FAMILIARE <---
      // commit("setUserAsValidNucleoFamiliare");
      //
      //
      // fondoest/issues#1349
      if (!storedUser?.primoAccesso || !storedUser?.dataDatiParticolari) {
        commit("setConsentToDeclare", true);
        router.push({
          name: "informativa",
          query: { type: "firstAccess" }
        });
      } else {
        router.push({ name: "dashboard" });
      }
    } catch (error) {
      let payload = {
        errorMsg: "dialog.error.keycloak-authorization"
      };
      commit("error/setKeycloakError", payload, { root: true });
    } finally {
      commit("loading/closeLoadingDialog", null, { root: true });
    }
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
